import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_dock_appointment_types_ddService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { option?: string }): 
  Promise<{ result: { Id?: number, Name?: string, Options?: string, SystemDefined?: boolean, SystemLabel?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_dock_appointment_types_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { option?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, Options?: string, SystemDefined?: boolean, SystemLabel?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_dock_appointment_types_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { option?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, Options?: string, SystemDefined?: boolean, SystemLabel?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_dock_appointment_types_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      option?: string    }) {
      return false;
    }
}
